import { requestNewServiceData } from "constants-lib/seo/requestNewServiceData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const requestNewService = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Request New Service JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addRequestNewService = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-request-a-new-service`,
    ) &&
    document.getElementById(`requestNewService`) === null
  ) {
    const script = requestNewServiceJSONLD()
    addJSONLDToHead(script, `requestNewService`)
  } else {
    removeElement(`requestNewService`)
  }
}

// JSON LD template for Request New Service
const requestNewServiceJSONLD = () => {
  const requestNewServiceTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: requestNewService(requestNewServiceData),
  }
  return requestNewServiceTemplate
}
